import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { CreditCard, Envelope, Person, Phone, PinMap } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";



export default function UserInfos({ codeuser }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [nom, setNom] = useState("");
    const [cni, setCni] = useState("");
    const [email, setEmail] = useState("");
    const [tel, setTel] = useState("");
    const [prenom, setPrenom] = useState("");
    const [nationalite, setNationnalite] = useState("");
    const [datecrea, setDatecrea] = useState('');
    const [type, setType] = useState('');
    const [client, setClient] = useState('');
    const [typecompte, setTypecompte] = useState([]);
    const [clientlist, setClientList] = useState([]);
    const [logo, setLogo] = useState('');
    const [logoprev, setLogoprev] = useState('/assets/imgs/no-image.png');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setLogo(file)
        TransformeLogo(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformeLogo = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setLogoprev(reader.result);
            };
        } else {
            setLogoprev("/assets/imgs/no-image.png");
        }
    };

    const getClientList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded);

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/customers`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.nom, value: element.code });
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (element.abr !== "WLC") {
                                clientarraydata2.push({ label: element.nom, value: element.code });
                            }
                        });

                        if (user?.isFullAction) {
                            setClientList(clientarraydata);
                        } else {
                            setClientList(clientarraydata2);
                            // setClient({label: clientarraydata2[0].label, value: clientarraydata2[0].value });
                        }
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("cash error", err);
        });
    }

    const getTypeCompte = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded);

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=typeutilisateur&page=1&limit=100000`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (element.abrev !== "superadmin") {
                                clientarraydata2.push({ label: element.lib, value: element.code });
                            }
                        });

                        if (user?.isFullAction) {
                            setTypecompte(clientarraydata);
                        } else {
                            setTypecompte(clientarraydata2)
                        }
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("cash error", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getUtilisateur = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/${codeuser}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        // setEtat(body?.etat);
                        setCni(body?.numcni !== null ? body?.numcni : "");
                        setNationnalite(body?.nationalite !== null ? body?.nationalite : "");
                        setNom(body?.nom !== null ? body?.nom : "");
                        setPrenom(body?.prenom !== null ? body?.prenom : "");
                        setTel(body?.numtel !== null ? body?.numtel : "");
                        setEmail(body?.email !== null ? body?.email : "");
                        setLogoprev(body?.photo !== null ? body?.photo : "/assets/imgs/blank.png")
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 19).replace("T", " à ") : "");
                        setClient(body?.code ? { label: body?.nomclient + " (" + body?.prenomclient + ")", value: body?.code } : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }


    // comportements
    useEffect(() => {
        getTypeCompte();
        getClientList();
        getUtilisateur();
    }, []);


    const handleDelete = async () => {
        confirmAlert({
            title: 'Delete?',
            message: 'Are you sure you want to delete this user?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/${codeuser}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage("User deleted successfully");
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete droit", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setDeleting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(config.texts.unavailblemsg);
                            setDeleting(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Update?',
            message: 'Are you sure you want to update this user informations?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (cni) urlencoded.append("numcni", cni);
                        urlencoded.append("nom", nom);
                        urlencoded.append("prenom", prenom);
                        if (logo) urlencoded.append("photo", logoprev);
                        // urlencoded.append("nat", nationalite);
                        if (email) urlencoded.append("email", email);
                        urlencoded.append("codeclient", client["value"]);
                        if (tel) urlencoded.append("numtel", tel);

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/${codeuser}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("User's informations updated successfully.");
                                setEditedstate(false);
                                getUtilisateur();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(config.texts.unavailblemsg);
                            setFetching(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    {!editedstate && <button onClick={() => setEditedstate(true)}
                                        title="Update user"
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Update</span>
                                    </button>}
                                    {!editedstate && <button onClick={handleDelete}
                                        title="Delete user"
                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-trash mr-1"></i> <span>Delete</span>  {deleting && <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />}
                                    </button>}
                                    <h6 className="m-0 ">User's informations</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{ width: "100%" }} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="row">
                                                    {editedstate && <div className="col-md-12 mb-2">
                                                        <label htmlFor="photo" className="form-label">Picture</label>
                                                        <input className="form-control" type="file" id="photo" onChange={handleLogoChange} />
                                                    </div>}
                                                    <div className="col-md-12 mb-1">
                                                        <img alt="" src={logoprev} className="rounded" style={{ width: "100%" }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8 mb-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="client" className="mb-1">Customer</label>
                                                        <Select
                                                            id="client"
                                                            name="client"
                                                            options={clientlist}
                                                            value={client}
                                                            onChange={(selected) => { setClient(selected); }}
                                                            isDisabled={editedstate ? false : true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="nom" className="mb-1">Firstname</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="nom">
                                                                <Person />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={nom}
                                                                onChange={(e) => setNom(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="prenom" className="mb-1">Lastname</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="prenom">
                                                                <Person />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={prenom}
                                                                onChange={(e) => setPrenom(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="nat" className="mb-1">Nationality</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="nat">
                                                                <PinMap />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={nationalite}
                                                                onChange={(e) => setNationnalite(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="cni" className="mb-1">Identity card number</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="cni">
                                                                <CreditCard />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={cni}
                                                                onChange={(e) => setCni(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="email" className="mb-1">Email addresss</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="email">
                                                                <Envelope />
                                                            </span>
                                                            <input type="email"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="tel1" className="mb-1">Phone number</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="tel1">
                                                                <Phone />
                                                            </span>
                                                            <input type="tel"
                                                                className="form-control"
                                                                placeholder={editedstate ? "Ex: 690000000" : ""}
                                                                value={tel}
                                                                onChange={(e) => setTel(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-12 mt-2">
                                                <button type="submit"
                                                    title="Update user's informations"
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                // disabled={names && statusinput["value"] ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i>
                                                    <span>Update</span> {fetching && <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditedstate(false)}
                                                    title="Cancel operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Cancel</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}